import React, { ChangeEvent, useEffect, useRef, useState } from 'react';
import Modal from "react-bootstrap/Modal";
import { Link, useNavigate } from 'react-router-dom';
import {
  MdMenu,
  MdSearch,
  MdPersonAdd,
  MdPinDrop,
  MdFavorite,
  MdShoppingBag,
  MdClose,
  MdDelete,
  MdOutlineFavorite,
  MdMoreVert,
} from 'react-icons/md';
import { emptycart, headerLogo } from '@/utils/imagepath';
import { routePrefix, routes } from '@/utils/routes/routes';
import store from '@/core/redux/store';
import { useDispatch } from 'react-redux';
import {
  setActiveCustomerTab,
  setHeader,
  setIsLoggedIn,
  setUserDetails,
  setWishListCount,
} from '@/core/redux/commonSlice';
import { toast } from 'react-toastify';
import { getData, postData } from '@/services/api.service';
import { error } from 'console';
import axios from 'axios';
import { end_points } from '@/services/endpoints';
// import SidebarDemo from '../../pages/Components/SidebarDemo';
import { Sidebar } from 'primereact/sidebar';
import { Button } from 'primereact/button';

import 'primereact/resources/themes/lara-light-blue/theme.css';
import 'primereact/resources/primereact.min.css';

import logo from '../../assets/img/20250325050540-removebg-preview.png';
import { useSelector } from 'react-redux';
import { RootState } from '@/core/redux/store';
import Spinner from '@/pages/Components/spinner';
import { removeCartItem } from '@/core/redux/cartSlice';
import { i } from 'react-router/dist/development/fog-of-war-Cm1iXIp7';
import { TbCircleX, TbHeart, TbMapPin, TbShoppingCart } from 'react-icons/tb';

interface SearchResult {
  id: number;
  name: string;
}

interface HeaderProps {
  wishlistCount: number;
  totalQty: number;
  topNavItems?: any;
}

const Header5: React.FC<any> = ({ themeData }: any) => {
  const [editData, setEditData] = useState<any>(themeData);

  const [value, setValue] = useState<string>('');
  const [results, setResults] = useState<SearchResult[]>([]);
  const [searchTimeout, setSearchTimeout] = useState<NodeJS.Timeout | null>(
    null
  );
  const [showSearchResult, setShowSearchResult] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const formRef = useRef<HTMLFormElement>(null);
  const [menuOpen, setMenuOpen] = useState(false);
  const [showSearchCanvas, setShowSearchCanvas] = useState(false);
  const [moreMenuOpen, setMoreMenuOpen] = useState(false);

  const toggleMoreMenu = () => {
    setMoreMenuOpen(!moreMenuOpen);
  };

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (formRef.current && !formRef.current.contains(event.target as Node)) {
        setResults([]); // close dropdown
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const user = store.getState().common.userDetails;
  const token = store.getState().common.token;

  // Update path if needed

  const dataCount = useSelector(
    (state: RootState) => state.common.wishListCount
  );
  const isLoggedIn = useSelector((state: RootState) => state.common.isLoading);
  const cartItems = useSelector((state: RootState) => state.cart.cartItems);
  const headerItems = useSelector((state: RootState) => state.common.header);
  const [visibleRight, setVisibleRight] = useState(false);

  const getHeader = async () => {
    try {
      const response = await getData(end_points.headers.url);
      dispatch(setHeader(response?.data?.data));
    } catch (error) {
      console.log(error);
    }
  };

  const getWishlistList = async () => {
    try {
      const payload = {
        user_id: user?.id,
        action: 'list',
      };
      const response = await postData('wishlist', payload);

      const items = response?.data?.data;
      console.log(items); // Your existing console log
      dispatch(setWishListCount(items?.length || 0));
    } catch (error) {
      console.log(error);
    }
  };
  const total = cartItems.reduce(
    (sum, item) => sum + item.price * item.quantity,
    0
  );

  useEffect(() => {
    isLoggedIn && getWishlistList();
    getHeader();
  }, [dataCount]);

  const handleSearch = (e: ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value;
    setValue(inputValue);

    if (searchTimeout) clearTimeout(searchTimeout);

    const timeout = setTimeout(async () => {
      if (inputValue.trim() !== '') {
        navigate(`${routePrefix}/search/${inputValue}`);
        setShowSearchCanvas(false);
      }
    }, 1000);

    setSearchTimeout(timeout);
  };

  const handleCheckout = () => {
    if (isLoggedIn) {
      if (cartItems?.length == 0) {
        toast.warn('Please add some products to your cart');
      } else {
        setVisibleRight(false);
        navigate(routes.checkout);
      }
    } else {
      toast.warn('Please login to Checkout');
    }
  };

  useEffect(() => {
    setEditData(themeData);
  }, [themeData]);

  useEffect(() => {
    if (editData != undefined) {
      setEditData(editData);
    }
  }, [editData]);

  return (
    <>
     
      <div
        id="header-middle"
        className={`header-middle py-2 ${menuOpen ? 'sidemenuopen' : ''}`}
      >
        <div className="container">
          <div className="d-flex justify-content-between align-items-center flex-wrap gap-3">
            {/* Logo */}
            <div className="d-flex align-items-center gap-lg-3 gap-2">
              <div
                className="category__menu show-on-mobile"
                onClick={toggleMenu}
              >
                <MdMenu size={24} />
              </div>
              <div className="d-flex align-items-center main-logo">
                <a href="/" className="h-100 d-flex align-items-center">
                  <img
                    alt="logo"
                    src={headerItems?.logo}
                    style={{
                      height: '100%',
                      objectFit: 'contain',
                    }}
                  />
                </a>
              </div>
              {/* More Menu (3-dots) - show on mobile only */}
              <div 
                className="category__menu show-on-mobile more-icon-trigger" 
                onClick={toggleMoreMenu}
                style={{ cursor: 'pointer', padding: '5px' }}
              >
                <MdMoreVert size={24} />
              </div>
            </div>


            {/* Search removed from center */}

            {/* User Icons */}
            <ul className={`offset-menu-wrapper d-flex align-items-center gap-lg-3 gap-2 list-unstyled mb-0 ${moreMenuOpen ? 'show-mobile-icons' : 'hide-on-mobile'}`} style={{ lineHeight: '1' }}>
              {!isLoggedIn ? (
                <li>
                  <Link to={routes.login}>Login</Link>
                </li>
              ) : (
                <li className="user-menu position-relative">
                  <MdPersonAdd size={22} />
                  <ul className="user-dropdown-menu">
                    <li>
                      <Link
                        to={routes.customerDashboard}
                        onClick={() => {
                          dispatch(setActiveCustomerTab('account-details'));
                        }}
                      >
                        My Account
                      </Link>
                    </li>
                    <li>
                      <Link
                        to={routes.customerDashboard}
                        onClick={() => {
                          dispatch(setActiveCustomerTab('orders'));
                        }}
                      >
                        Order History
                      </Link>
                    </li>
                    <li>
                      <Link
                        to={routes.customerDashboard}
                        onClick={() => {
                          dispatch(setActiveCustomerTab('address'));
                        }}
                      >
                        Addresses
                      </Link>
                    </li>
                    <li>
                      <Link
                        to={''}
                        onClick={() => {
                          localStorage.clear();
                          dispatch(setUserDetails({}));
                          dispatch(setIsLoggedIn(false));
                          navigate(routes.login);
                        }}
                      >
                        Logout
                      </Link>
                    </li>
                  </ul>
                </li>
              )}
              <li>
                <button
                  className="border-0 bg-transparent p-0"
                  onClick={() => setShowSearchCanvas(true)}
                  title="Search"
                >
                  <MdSearch size={22} />
                </button>
              </li>
              <li>
                <Link
                  to={isLoggedIn ? routes.trackOrder : routes.login}
                  onClick={() =>
                    !isLoggedIn && toast.warning('Please Login to Tract Order')
                  }
                  title="Track Order"
                >
                  <TbMapPin size={22} />
                </Link>
              </li>
              <li className="cart__menu position-relative">
                <Link
                  to={isLoggedIn ? routes.customerDashboard : routes.login}
                  onClick={() => {
                    if (isLoggedIn) {
                      dispatch(setActiveCustomerTab('wishlist'));
                    } else {
                      toast.warning('Please Login to Wishlist');
                      navigate(routes.login);
                    }
                  }}
                  title="Wishlist"
                >
                  <TbHeart size={22} />
                </Link>

                <span className="badge badge-light cart_qty position-absolute start-100 translate-middle">
                  {isLoggedIn ? dataCount : 0}
                </span>
              </li>
              <li className="cart__menu position-relative">
                <button
                  label="Right"
                  className="border-0 bg-transparent"
                  onClick={() => {
                    setVisibleRight(true);
                  }}
                >
                  {/* <button type='button'></button> */}
                  <TbShoppingCart size={22} title="Cart" />
                  <span className="badge badge-light cart_qty position-absolute start-100 translate-middle">
                    {cartItems?.length}
                  </span>
                </button>
              </li>
            </ul>
            <Sidebar
              visible={visibleRight}
              position="right"
              onHide={() => setVisibleRight(false)}
              showCloseIcon={false}
              className="custom-sidebar"
            >
              {/* Header */}
              <div className="cart-header">
                <div className="cart-title">My Cart</div>
                <Button
                  icon={<MdClose size={20} />}
                  className="p-button-text p-button-rounded p-button-danger cart-close-btn"
                  onClick={() => setVisibleRight(false)}
                />
              </div>

              {/* Content */}
              {cartItems?.length > 0 ? (
                <div className="cart-content">
                  {cartItems.map((item, index) => (
                    <div key={index} className="cart-item">
                      <div className="cart-item-details">
                        <div className="cart-description">
                          <div className="cart-image">
                            <img
                              src={item?.image}
                              alt={item?.name}
                              className="img-fluid"
                            />
                          </div>
                          <div className="cart-info-details">
                            <div className="cart-title">
                              <p>{item?.name}</p>
                            </div>
                            <div className="quantity">
                              <p>
                                <span className="text-muted">
                                  {item.variant && `(${item.variant}) `}
                                </span>
                                {item?.quantity} x {item?.price}
                              </p>
                            </div>
                          </div>
                        </div>

                        <div className="cart-remove">
                          <button
                            onClick={() => dispatch(removeCartItem(item?.id))}
                          >
                            <MdDelete size={20} color="red" />
                          </button>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <div className="empty-cart-content">
                  <img
                    src={emptycart}
                    alt="Empty Cart"
                    className="empty-cart-image"
                  />
                  <p className="empty-cart-text">
                    Your cart is currently empty
                  </p>
                  <Link to={routes?.home} className="shop-now-btn">
                    Shop Now
                  </Link>
                </div>
              )}

              {/* Footer */}
              <div className="cart-footer">
                <span>Subtotal:</span>
                <span className="subtotal-amount">{total.toFixed(2)}</span>
              </div>
              <div className="cart-footer-btns d-flex ">
                <Link
                  to={routes.cart}
                  className="btn btn-primary w-100 m-2"
                  onClick={() => setVisibleRight(false)}
                >
                  View Cart
                </Link>
                <button
                  className="btn btn-secondary w-100 m-2"
                  onClick={handleCheckout}
                >
                  Checkout
                </button>
              </div>
            </Sidebar>
          </div>
        </div>
        <div className="mob-menu-container">
          <div className="d-flex justify-content-between mob-menu-hdr align-items-center">
            <img alt="logo" src={headerItems?.logo} />
            {menuOpen && <TbCircleX size={24} onClick={toggleMenu} />}
          </div>
          <ul>
            {headerItems?.headers?.map((data: any) => {
              if (data?.slug == '#') return;
              return (
                <li>
                  <Link
                    to={`${data?.slug == '#' ? '#' : routePrefix + '/' + data?.slug}`}
                  >
                    {data?.title}
                  </Link>
                </li>
              );
            })}
          </ul>
        </div>
        {menuOpen && (
          <div className="sidebar-overlay" onClick={toggleMenu}></div>
        )}
      </div>
      <Modal
        show={showSearchCanvas}
        onHide={() => setShowSearchCanvas(false)}
        size="lg"
        className="search-modal"
      >
        <Modal.Header closeButton className="border-0 pb-0">
          <Modal.Title className="w-100 text-center">Search Products</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-4">
          <form
            ref={formRef}
            onSubmit={(e) => {
              e.preventDefault();
              if (value.trim() !== '') {
                if (searchTimeout) clearTimeout(searchTimeout);
                navigate(`${routePrefix}/search/${value}`);
                setShowSearchCanvas(false);
              }
            }}
          >
            <div className="input-group">
              <input
                id="search"
                type="text"
                placeholder="Search products..."
                name="search"
                className="form-control"
                value={value}
                onChange={handleSearch}
                style={{ height: '50px' }}
              />
              <button
                className="btn btn-primary d-flex align-items-center justify-content-center"
                type="submit"
                style={{
                  width: '60px',
                  backgroundColor: '#007bff',
                  borderTopRightRadius: '4px',
                  borderBottomRightRadius: '4px',
                }}
              >
                <MdSearch size={24} />
              </button>
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default React.memo(Header5);
